import { render, staticRenderFns } from "./OptOutQuestion.vue?vue&type=template&id=06aa7815&"
import script from "./OptOutQuestion.vue?vue&type=script&lang=js&"
export * from "./OptOutQuestion.vue?vue&type=script&lang=js&"
import style0 from "./OptOutQuestion.vue?vue&type=style&index=0&id=06aa7815&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports